import { httpClient } from '@ahm/api-wrappers-core';
import { apiRoutes } from '../api-routes';

export interface RecentContact {
  name: string;
  mobile: string;
  type: 'sender' | 'recipient';
}

export const getRecentContactFn = async () => {
  const res = await httpClient.get<RecentContact[]>(
    apiRoutes.order.recentContact
  );
  return res.data;
};
